import { Component, OnInit } from '@angular/core';
import { ConnectionService } from 'src/app/services/connection.service';
import { Plate } from '../../models/plate.model';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class CostComponent implements OnInit {
  plates: Plate[]

  //inversion es harina 6000 + queso 10000 por ejemplo
  //la inversion la tiene el costo por ingrediente, se debe sumar en funcion del producto
  //es decir, costo ingrediente 1 + costo ingrediente 2 y asi
  item: any = {
    quantity: '',
    gain: '',
    result1: '',
    result2: '',
    result3: '',
    inversion: '16000'
  }

  constructor(private connection: ConnectionService) { }

  ngOnInit() {
   // this.connection.getPlates()
    //  .subscribe(data => this.plates = data)
  }

  onKeyup(event) {
    console.log(event);
    
    //calculo de precio de venta por producto:

    //dividir inversion en bs entre el total de tequenos
    this.item.result1 = this.item.inversion / this.item.quantity
    //multiplicar ese valor por el porcentaje de ganancia
    this.item.result2 = this.item.result1 * this.item.gain

    this.item.result3 = this.item.result1 + this.item.result2

    console.log(this.item.result)
  }

}
